import { I18nProvider } from "@lingui/react";
import { i18n } from "@lingui/core";
import { useEffect, useState } from "react";
import { retrieveBrowserLocale } from "./Utils/i18n";
import { Helmet } from "@dr.pogodin/react-helmet";
import * as Sentry from "@sentry/react";

async function dynamicActivate(locale: "en" | "sv" | "de" | "lv") {
  const { messages } = await import(`./locales/${locale}.ts`);
  i18n.load(locale, messages);
  i18n.activate(locale);
}

export const I18nApp = ({ children }: { children: React.ReactNode }) => {
  const browserLocale = retrieveBrowserLocale();

  const [translationActive, setTranslationActive] = useState(false);
  useEffect(() => {
    dynamicActivate(browserLocale)
      .then(() => setTranslationActive(true))
      .catch((error: unknown) => Sentry.captureException(error));
  }, [browserLocale]);
  // Not sure if controlling `translationActive` state is necessary
  // but it stops I18nProvider from rendering with `null`
  // which causes it to render an informative message that could be disturbing
  if (!translationActive) {
    return null;
  }
  return (
    <I18nProvider i18n={i18n}>
      <>
        <Helmet>
          <html lang={browserLocale} />
        </Helmet>
        {children}
      </>
    </I18nProvider>
  );
};
